import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { Container, Row, Col, Nav, Breadcrumb, Modal } from "react-bootstrap";
import { FaInfoCircle, FaMapMarkerAlt, FaImages } from "react-icons/fa";
// import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { goToBlock } from "../utils/navigation";


const SingleProduct = () => {
  const { state } = useLocation();
  const [activeTab, setActiveTab] = useState("Information");
  const [bannerIndex, setBannerIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  const destination = state?.destination;
  const title = state?.title || "Attraction";
  const subtitle = state?.subtitle || "Destinations";
  const images = Array.isArray(state?.images) ? state.images : [];
  const description = Array.isArray(state?.description) ? state.description : [state?.description || ""];
  const history = Array.isArray(state?.history) ? state.history : [];
  const bestTimeToVisit = Array.isArray(state?.bestTimeToVisit) ? state.bestTimeToVisit : [];
  const howToReach = Array.isArray(state?.howToReach) ? state.howToReach : [];
  const nearbyAttractions = Array.isArray(state?.nearbyAttractions) ? state.nearbyAttractions : [];

  // Open modal at clicked index
  const openModal = (index) => {
    setCurrentIndex(index);
    setModalOpen(true);
  };

  // Navigate
  const prevImage = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextImage = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    if (images.length > 1) {
      const interval = setInterval(() => {
        setBannerIndex((prev) => (prev + 1) % images.length);
      }, 4000);
      return () => clearInterval(interval);
    }
  }, [images]);

  return (
    <div>
      {/* === Banner with Gradient Overlay === */}
      <div
        style={{
          position: "relative",
          height: "350px",
          width: "100%",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontSize: "2.5rem",
          fontWeight: "bold",
          textShadow: "2px 2px 10px rgba(0,0,0,0.7)",
        }}
      >
        {/* Banner Image */}
        <img
          src={images[bannerIndex] || "/images/gallery.jpg"}
          alt="Banner"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover", // fills space, less harsh crop
            objectPosition: "center",
            zIndex: 0,
            transition: "opacity 0.8s ease-in-out",
          }}
        />

        {/* Dark Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.2))",
            zIndex: 1,
          }}
        />

        {/* Title */}
        <div style={{ zIndex: 2 }}>{title}</div>
      </div>

      {/* === Breadcrumb === */}
      <Container className="my-3">
        <Breadcrumb>

          <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
            <span
              style={{
                color: "#0d6efd",
                textDecoration: "none",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "#0a58ca";
                e.currentTarget.style.textDecoration = "underline";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "#0d6efd";
                e.currentTarget.style.textDecoration = "none";
              }}
            >
              Home
            </span>
          </Breadcrumb.Item>

          <Breadcrumb.Item active>
            <span
              style={{
                color: "#6c757d",
                fontWeight: 500,
                cursor: "default",
              }}
            >
              {subtitle}
            </span>
          </Breadcrumb.Item>

          <Breadcrumb.Item active>
            <span style={{ color: "#6c757d", cursor: "default" }}>{title}</span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </Container>

      <Container className="border-bottom mb-4">
        <Nav variant="tabs" activeKey={activeTab} onSelect={(tab) => setActiveTab(tab)}>
          <Nav.Item>
            <Nav.Link eventKey="Information"><FaInfoCircle className="me-2" />Information</Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link eventKey="Gallery"><FaImages className="me-2" />Gallery</Nav.Link>
          </Nav.Item>
        </Nav>
      </Container>

      {/* === Tab Content === */}
      <Container>
        {activeTab === "Information" && (
          <Row>
            <Col lg={8}>
              {description.map((para, i) => (
                <p key={i} className="text-secondary">
                  {i === 0 ? <h5 className="mt-4 fw-bold text-dark">About The Location</h5> : null} {para}
                </p>
              ))}

              {history.length > 0 && (
                <>
                  <h5 className="mt-4 fw-bold text-dark">Significance</h5>
                  <ul className="text-secondary">{history.map((point, i) => <li key={i}>{point}</li>)}</ul>
                </>
              )}

              {bestTimeToVisit.length > 0 && (
                <>
                  <h5 className="mt-4 fw-bold text-dark">Best Time to Visit</h5>
                  <ul className="text-secondary">{bestTimeToVisit.map((time, i) => <li key={i}>{time}</li>)}</ul>
                </>
              )}
            </Col>

            {/* Sidebar Location */}
            <Col lg={4} >
              <div className="shadow-sm rounded overflow-hidden">
                <iframe
                  title="Google Maps"
                  src={`https://maps.google.com/maps?q=${encodeURIComponent(title)}&t=&z=13&ie=UTF8&iwloc=&output=embed`}
                  width="100%"
                  height="500"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                ></iframe>
              </div>
            </Col>
          </Row>
        )}

        {activeTab === "Gallery" && (
          <>
            <Row className="g-2">
              {images.map((src, idx) => (
                <Col xs={6} sm={4} md={3} key={idx}>
                  <div
                    className="position-relative overflow-hidden"
                    style={{
                      cursor: "pointer",
                      borderRadius: "8px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                      overflow: "hidden",
                      height: "180px",
                    }}
                    onClick={() => openModal(idx)}
                    onMouseEnter={(e) => {
                      const img = e.currentTarget.querySelector("img");
                      const overlay = e.currentTarget.querySelector(".overlay");
                      img.style.transform = "scale(1.05)";
                      overlay.style.opacity = 1;
                    }}
                    onMouseLeave={(e) => {
                      const img = e.currentTarget.querySelector("img");
                      const overlay = e.currentTarget.querySelector(".overlay");
                      img.style.transform = "scale(1)";
                      overlay.style.opacity = 0;
                    }}
                  >
                    <img
                      src={src}
                      alt={`Gallery ${idx + 1}`}
                      className="w-100 h-100"
                      style={{
                        objectFit: "cover",
                        transition: "transform 0.3s ease",
                      }}
                    />
                    {/* Overlay */}
                    <div
                      className="overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                      style={{
                        background: "rgba(0,0,0,0.3)",
                        color: "#fff",
                        fontSize: "0.9rem",
                        fontWeight: "500",
                        opacity: 0,
                        transition: "opacity 0.3s ease",
                      }}
                    >
                      View
                    </div>
                  </div>
                </Col>
              ))}
            </Row>

            {/* Image Modal */}
            <Modal
              show={modalOpen}
              onHide={() => setModalOpen(false)}
              centered
              size="lg"
            >
              <Modal.Body className="p-0 position-relative">
                <img
                  src={images[currentIndex]}
                  alt={`Preview ${currentIndex + 1}`}
                  className="w-100"
                  style={{ maxHeight: "80vh", objectFit: "contain" }}
                />

                <button
                  onClick={() => setModalOpen(false)}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "rgba(0,0,0,0.6)",
                    border: "none",
                    borderRadius: "50%",
                    width: "35px",
                    height: "35px",
                    color: "#fff",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    lineHeight: "1",
                    cursor: "pointer",
                  }}
                >
                  ×
                </button>

                <button
                  onClick={prevImage}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    background: "rgba(0,0,0,0.5)",
                    border: "none",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    color: "#fff",
                    fontSize: "1.5rem",
                    cursor: "pointer",
                  }}
                >
                  ‹
                </button>

                <button
                  onClick={nextImage}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "10px",
                    transform: "translateY(-50%)",
                    background: "rgba(0,0,0,0.5)",
                    border: "none",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    color: "#fff",
                    fontSize: "1.5rem",
                    cursor: "pointer",
                  }}
                >
                  ›
                </button>
              </Modal.Body>
            </Modal>
          </>
        )}

        {/* How to Reach */}
        {howToReach.length > 0 && (
          <div className="mt-5 p-4 rounded bg-light shadow-sm">
            <h4 className="fw-bold mb-4">How to Get There</h4>
            {howToReach.map((way, i) => (
              <div key={i} className="d-flex align-items-start mb-4">
                <img
                  src={way.icon}
                  alt={way.label}
                  style={{ width: "50px", height: "50px", objectFit: "contain", marginRight: "1rem" }}
                />
                <div>
                  <h6 className="fw-bold">{way.label}</h6>
                  <p className="text-secondary">{way.detail}</p>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Nearby Attractions */}
        {nearbyAttractions.length > 0 && (
          <div className="mt-5 p-4 rounded bg-white shadow-sm">
            <h4 className="fw-bold mb-4">Other Highlights</h4>
            <Row>
              {nearbyAttractions.map((item, idx) => {
                const fullBlock =
                  destination?.data?.find(
                    (block) => block.title.toLowerCase() === item.alt.toLowerCase()
                  ) || null;

                return (
                  <Col md={3} sm={6} xs={12} key={idx} className="mb-3">
                    <div
                      className="position-relative rounded shadow-sm overflow-hidden"
                      style={{
                        cursor: fullBlock ? "pointer" : "not-allowed",
                        borderRadius: "12px",
                        transition: "transform 0.25s ease, box-shadow 0.25s ease",
                      }}
                      onClick={() => goToBlock(navigate, fullBlock, subtitle, destination)}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-6px)";
                        e.currentTarget.style.boxShadow = "0 8px 18px rgba(0,0,0,0.25)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.15)";
                      }}
                    >
                      {/* Thumbnail */}
                      <img
                        src={item.img}
                        alt={item.alt}
                        className="img-fluid w-100"
                        style={{
                          height: "180px", // smaller card height
                          objectFit: "cover",
                        }}
                      />

                      {/* Overlay with title */}
                      <div
                        className="position-absolute bottom-0 start-0 w-100 text-center py-2"
                        style={{
                          background: "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0))",
                          color: "#fff",
                          fontSize: "0.95rem",
                          fontWeight: "600",
                        }}
                      >
                        {item.alt}
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        )}
      </Container>
    </div>
  );
};

export default SingleProduct;